<template>
  <div class="wrapper pagination pagination-absolute">
    <Menu />
    <div class="body-area">
      <div class="container-fluid">
        <div class="row">
          <div v-if="data.related.news.length != 0" class="col-12 p-0">
            <carousel
              :perPage="1"
              paginationActiveColor="#fff"
              paginationColor="rgba(255,255,255,.43)"
            >
              <slide v-for="item in data.related.news.slice().reverse()" :key="item.slug">
                <div
                  class="slider-box position-relative"
                  @click="getNews(item.slug)"
                >
                  <img :src="item.original" class="w-100 slider-image" />
                  <h1 class="fs-32 fc-5 slider-title position-absolute z-9">
                    {{ item.title }}
                  </h1>
                </div>
              </slide>
            </carousel>
          </div>

          <div class="col-12 py-4">
            <div class="row no-gutters">
              <div class="col-12">
                <span class="fs-10 fc-3"
                  >{{
                    data.homeTeam.name.toLowerCase() == "anadolu efes"
                      ? data.awayTeam.name
                      : data.homeTeam.name
                  }}
                  maçına kalan süre:</span
                >
              </div>
              <div
                class="col-7"
                v-if="data.dateTime != null && duration != null"
              >
                <ul class="time-clock clearfix d-flex">
                  <li>
                    <span class="time">{{ duration.hours() }}</span
                    >Saat
                  </li>
                  <li class="half-clock align-self-center">
                    <span>:</span>
                  </li>
                  <li>
                    <span class="time">{{ duration.minutes() }}</span
                    >Dakika
                  </li>
                  <li class="half-clock align-self-center">
                    <span>:</span>
                  </li>
                  <li>
                    <span class="time">{{ duration.seconds() }}</span
                    >Saniye
                  </li>
                </ul>
              </div>
              <div
                class="col-5"
                v-if="data.ticket_link != null && data.ticket_link != ''"
              >
                <button
                  class="red-button mt-9 px-0"
                  @click="$buy(data.ticket_link)"
                >
                  Maça Bilet Al!
                </button>
              </div>
            </div>

            <button
              v-if="
                checked_in == false &&
                  $store.state.app.match.related_campaign != null
              "
              @click="checkIn"
              class="confirm-button mt-2"
            >
              {{
                $store.state.user != null &&
                $store.state.app.match.related_campaign != null
                  ? "Check-in"
                  : "Check-in için giriş yap"
              }}
            </button>
            <button
              v-if="checked_in == true"
              @click="checkIn"
              class="confirm-button mt-2"
            >
              Check-in Yaptınız
            </button>
          </div>
          <Mvp :data="stats" v-if="stats.length != 0" />
          <div class="col-12 text-center pt-3 pb-3">
            <a
              href="javascript:;"
              v-if="!$store.getters.isLogged"
              @click="$router.push({ name: 'Login' })"
            >
              <img :src="$store.state.ads.nofanclub.srcUrl" alt class="w-100" />
            </a>

            <div v-if="$store.getters.isLogged">
              <iframe
                :src="$store.state.ads.home.srcUrl"
                style="width: 100%;"
                :style="
                  'height: calc(' +
                    parseInt($store.state.ads.home.height.replace('%', '')) +
                    'vw'
                "
              ></iframe>
            </div>
          </div>
          <CampaignCarousel :data="campaigns" />
          <div class="col-12 p-0 mt-2">
            <div
              class="item-box text-center p-3"
              v-if="data.previous_match != null"
            >
              <h1 class="fs-14 fc-6">ÖNCEKİ MAÇ</h1>
              <span class="fs-12 fc-3"
                >{{ data.previous_match.league }},
                {{ data.previous_match.court }}</span
              >
              <div class="team-band">
                <div class="team-block">
                  <div class="team one">
                    <img
                      style="height: 100px"
                      class="img-responsive"
                      :src="data.previous_match.homeTeam.logo_url"
                      alt
                    />
                    <p class="fs-14 fc-2">
                      {{ data.previous_match.homeTeam.name }}
                    </p>
                  </div>
                </div>
                <div class="skor-final">
                  <div class="detail pt-4">
                    <p class="fs-14 fc-2 font-weight-bold m-0">
                      {{ data.previous_match.homeTeam.score }}
                      <span class="px-1">:</span>
                      {{ data.previous_match.awayTeam.score }}
                    </p>
                    <p class="perriod fs-14 fc-3 font-weight-bold">MS</p>
                  </div>
                </div>
                <div class="team-block">
                  <div class="team one">
                    <img
                      style="height: 100px"
                      class="img-responsive"
                      :src="data.previous_match.awayTeam.logo_url"
                      alt
                    />
                    <p class="fs-14 fc-2">
                      {{ data.previous_match.awayTeam.name }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="row no-gutters bg-2 bb-1 bt-1"
              @click="
                $router.push({
                  name: 'HomeAfterMatch',
                  params: { id: data.previous_match.id }
                })
              "
            >
              <div class="col-12 br-1">
                <div class="block-link text-center pt-3 pb-3">
                  <h1 class="fc-1 fs-14">
                    <img src="/static/img/fixture-dot.svg" class="mr-2" /> Maç
                    Sayfasına Git
                  </h1>
                </div>
              </div>
            </div>
            <Comment @commentDeleted="getComments" :data="comments">
              <template v-slot:comment>
                <div class="add-comment">
                  <div class="comment-image">
                    <img
                      :src="$store.state.user.avatarUrl"
                      class="w-100 rounded-circle"
                    />
                  </div>
                  <div class="comment-area">
                    <textarea
                      placeholder="Yorum Yaz"
                      class="comment-input mt-2"
                      v-model="comment"
                    ></textarea>
                    <button
                      @click="sendComment"
                      class="confirm-button"
                      v-if="comment != null && comment != ''"
                    >
                      Yorum Yap
                    </button>
                  </div>
                </div>
              </template>
            </Comment>

          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Footer from "@/components/Footer";
import Menu from "@/components/Menu";
import Comment from "@/components/Comment";
import Mvp from "@/components/Mvp";
import CampaignCarousel from "@/components/CampaignCarousel";
import axios from "axios";
import moment from "moment";

export default {
  name: "HomeMatchDay",
  props: ["title"],
  components: {
    Footer,
    Menu,
    Comment,
    Mvp,
    CampaignCarousel
  },
  data() {
    return {
      currentDate: Date.now(),
      moment,
      activeTab: 1,
      data: {
        dateTime: null,
        ticket_link: null,
        previous_match: null,
        nextMatch: null,
        stats: {
          home: null
        },
        related: {
          news: []
        },
        league: null,
        fixture: null,
        homeTeam: {
          name: null,
          logo_url: ""
        },
        awayTeam: {
          name: null,
          logo_url: ""
        },
        scores: {
          home: {
            final: 0,
            Q1: 21,
            Q2: 23,
            Q3: 25,
            Q4: 20
          },
          away: {
            final: 0,
            Q1: 21,
            Q2: 23,
            Q3: 25,
            Q4: 20
          }
        }
      },
      activeSlide: 0,
      id: this.$store.state.app.match.id,
      stats: [],
      activeStat: "home",
      gallery: [],
      comments: [],
      comment: null,
      loading: true,
      campaigns: [],
      infoModalVisible: false,
      info: {
        bonus: { is_available: false },
        button_text: null,
        button_url: null,
        code: "XXXXXXX",
        message:
          "Tebrikler! [CODE] kodunu Kahve Dünyası mobil uygulamasından aktif edebilirsin.",
        status: true,
        user: { total_point: 0 }
      },
      latitude: null,
      longitude: null,
      checked_in: false,
      currentTime: 0,
      duration: null
    };
  },
  created() {
    this.$store.state.loading = true;
  },
  beforeMount() {
    setInterval(() => {
      this.currentDate = Date.now();

      var diff = this.data.dateTime - this.currentDate;
      var duration = moment.duration(diff, "milliseconds");
      this.duration = moment.duration(duration - 1000, "milliseconds");
    }, 1000);

    var data = new FormData();
    data.append("id", this.$store.state.app.match.related_campaign);

    if (this.$store.state.user != null) {
      data.append("email", this.$store.state.user.email);
      data.append("token", this.$store.state.user.token);

      axios.post("kampanya/checkin-olmus-mu", data).then(res => {
        this.checked_in = res.data.checked_in;
      });
    }

    axios.post("kampanya/liste").then(res => {
      var data = [];
      res.data.data.map((item, index) => {
        if (index <= 4) {
          data.push(item);
        }
      });
      this.campaigns = data;
    });
    axios.get("istatistik/detay?id=" + this.id).then(res => {
      this.data = res.data.data;
      this.data.dateTime = res.data.data.timestamp * 1000;
      var data = [];

      res.data.data.highlights.map(item => {
        data.push({
          name: item.name,
          photo: item.image,
          stats: [
            {
              title: "Sayı",
              value: item.statistics.all.score
            },
            {
              title: "Ribaund",
              value: item.statistics.all.totalRebounds
            },
            {
              title: "Asist",
              value: item.statistics.all.assists
            }
          ]
        });
      });

      this.stats = data;

      setTimeout(() => {
        this.$store.state.loading = false;
      }, 250);
    });

    this.getComments();
  },
  methods: {
    getNews(slug) {
      this.$store.state.loading = true;
      axios.get("/haber/detay?slug=" + slug).then(res => {
        this.$store.state.loading = false;
        this.$router.push({
          name: "NewsDetail",
          params: { data: res.data.data, slug }
        });
      });
    },
    getComments() {
      var data = new FormData();
      data.append("id", this.$store.state.app.match.id);
      data.append("type", "match");
      data.append("user_token", this.$store.state.user.token);
      axios.post("yorum", data).then(res => {
        this.comments = res.data.data.comments;
      });
    },
    checkIn() {
      if (this.$store.state.user == null) {
        this.$router.push({ name: "Login" });
      } else {
        this.$store.state.loading = true;
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            pos => {
              var data = new FormData();
              data.append("id", this.$store.state.app.match.related_campaign);
              data.append("email", this.$store.state.user.email);
              data.append("token", this.$store.state.user.token);
              data.append("latitude", pos.coords.latitude);
              data.append("longitude", pos.coords.longitude);

              axios.post("kampanya/katil", data).then(res => {
                this.$store.state.loading = false;
                if (res.data.data.status == true) {
                  this.checked_in = true;

                  this.$router.push({
                    name: "Success",
                    params: { data: res.data.data }
                  });
                } else {
                  this.$notify({
                    title: "Hata",
                    message: res.data.data.error,
                    type: "error"
                  });
                }
              });
            },
            error => {
              this.$store.state.loading = false;
              switch (error.code) {
                case error.PERMISSION_DENIED:
                  this.$notify({
                    title: "Hata",
                    message:
                      "Konum izni vermediğiniz için check-in yapamazsınız. Lütfen ayarlardan izin erip tekrar deneyin.",
                    type: "error"
                  });
                  break;
                case error.POSITION_UNAVAILABLE:
                  this.$notify({
                    title: "Hata",
                    message:
                      "Konum alınamadı. Telefonunuzun internet ve gps bağlantısının olduğundan emin olun.",
                    type: "error"
                  });
                  break;
                case error.TIMEOUT:
                  this.$notify({
                    title: "Hata",
                    message:
                      "Konumunuzu almamız çok uzun sürdü. Lütfen tekrar deneyin",
                    type: "error"
                  });
                  break;
                case error.UNKNOWN_ERROR:
                  this.$notify({
                    title: "Hata",
                    message:
                      "Bilinmeyen bir hata oluştur. Lütfen tekrar deneyin.",
                    type: "error"
                  });
                  break;
              }
            }
          );
        }
      }
    },
    sendComment() {
      var data = new FormData();

      data.append("user_token", this.$store.state.user.token);
      data.append("comment", this.comment);
      data.append("type", "match");
      data.append("id", this.$store.state.app.match.id);

      axios
        .post("yorum/ekle", data)
        .then(res => {
          if (res.data.status != true) {
            this.$notify({
              title: "Hata",
              message: res.data.data,
              type: "error"
            });
          } else {
            this.comment = null;
            this.getComments();
            this.$notify({
              title: "Başarılı",
              message: "Başarıyla yorum yapıldı.",
              type: "success"
            });
          }

          this.getComments();
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/HomeMatchDay.vue